import i18n from "i18next";
import { ShowConfirmDialogFunc } from "src/components/common/dialogs/confirmDialog/ConfirmDialogContext.ts";

export async function confirmUnsavedChangesWillBeLost(
	showConfirmDialog: ShowConfirmDialogFunc,
	customMessage?: string,
) {
	return await showConfirmDialog({
		title: i18n.t("unsaved_changes"),
		message: customMessage ?? i18n.t("unsaved_changes_will_be_lost"),
	});
}
